import classNames from 'classnames';

export const Center = ({ children, className, ...r }) => {
  const classnames = classNames(
    'center-options flex',
    className
  );

  return (
    <div className={classnames} {...r}>
      {children}
    </div>
  );
};
